module.exports = __webpack_public_path__ + "img/zbBg1.049679af.png";